import React from "react";
import { Comment, List, Tooltip } from 'antd';
import moment from 'moment';
import anuar from "@images/photos/anuar.jpg";
import daniyar from "@images/photos/daniyar.jpg";



const Comments = () => {

    const data = [
        {
            actions: [<span key="comment-list-reply-to-0">Ответ</span>],
            author: 'Ануар Оразбеков',
            avatar: `${anuar}`,
            content: (
                <p>
                    П. 143 ЕТ- не соответствует, дверь в основное серверное помещение открывается вовнутрь.
                </p>
            ),
            datetime: (
                <Tooltip title={moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')}>
                    <span>{moment().subtract(1, 'days').fromNow()}</span>
                </Tooltip>
            ),
        },
        {
            actions: [<span key="comment-list-reply-to-0">Ответ</span>],
            author: 'Данияр Олегов',
            avatar: `${daniyar}`,
            content: (
                <p>
                    п.146 ППРК ЕТ.
                    Монтаж коммуникационных каналов для прокладки силовых и слаботочных кабельных сетей здания
                    выполняется в отдельных или разделенных перегородками кабельных лотках, коробах или трубах,
                    разнесенных между собой. Прокладка кабелей через перекрытия, стены, перегородки осуществляется
                    в отрезках несгораемых труб с герметизацией негорючими материалами.
                </p>
            ),
            datetime: (
                <Tooltip title={moment().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')}>
                    <span>{moment().subtract(2, 'days').fromNow()}</span>
                </Tooltip>
            ),
        },
    ];

    return (
        <>
            <List
                className="comment-list"
                header={`${data.length} замечания`}
                itemLayout="horizontal"
                dataSource={data}
                renderItem={item => (
                    <li>
                        <Comment
                            actions={item.actions}
                            author={item.author}
                            avatar={item.avatar}
                            content={item.content}
                            datetime={item.datetime}
                        />
                    </li>
                )}
            />
        </>
    )
}

export default Comments;
